import React, { Component } from 'react'
import Event from './Event'

import { db } from '../../firebase.js'

class Calendar extends Component {
  constructor() {
    super()
    this.state = {
      events: []
    }
  }

  componentDidMount() {
    const dbEvents = db.ref('events')
    dbEvents.on('value', (snapshot) => {
      let events = snapshot.val()
      let newState = []
      for (let event in events) {
        newState.push({
          id: event,
					fulldate: events[event].fulldate,
          headline: events[event].headline,
          bodytext: events[event].bodytext,
          link: events[event].link
        })
      }
      this.setState({
        events: newState.sort((a, b) => {return a.fulldate - b.fulldate})
      })
		})
  }

  render() {
    return (
      <section className="w-100 bg-moon-gray flex flex-column pa2">
        <div className="pb3 pathway f1 self-end">UPCOMING EVENTS</div>
        {this.state.events.map( (event) => {
          return (
            <Event event={event} 
                   key={event.id}
                   fulldate={event.fulldate}
                   headline={event.headline}
                   bodytext={event.bodytext}
                   link={event.link}
            />
          )
        })}
      </section>
    )
  }
}

export default Calendar


// WEBPACK FOOTER //
// ./src/components/multi/Calendar.js